import { createTheme } from "@mui/material/styles";

/**
 * MUI app theme, used to apply IPF specific styling to MUI components.
 */
export const AppTheme = createTheme({
    palette: {
        primary: {
			main: "#303849"
        },
        secondary: {
			main: '#328589'
        },
	},
	typography: {
		fontFamily: [
			'Inter',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
	},
});